import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import useRadioStyles from './Radio.Styles';
export const DefaultProps = {
    value: '',
    checked: false,
    color: 'black',
    disabled: false
};
// Component
export const Radio = ({ value, name, color, label, width, disabled, checked, sx, ...props }) => {
    const theme = useTheme();
    const styles = useRadioStyles({
        ...{ disabled, value, color, width, ...props },
        theme
    });
    return (_jsxs("div", { className: styles.container, children: [_jsxs("label", { className: `${styles.radioButtonBase} ${disabled ? styles.disabled : styles.enabled} ${checked ? styles.checked : ''}`, style: sx, children: [_jsx("input", { className: `RadioButtonInput ${styles.input}`, value: value, type: "radio", disabled: disabled, name: name, checked: checked, ...props }), _jsx("span", { className: `RadioButtonCheckmark ${styles.checkmark}` })] }), label && _jsx("span", { className: styles.label, children: label })] }));
};
export default Radio;
